import classNames from "classnames";
import PageContainer from "modules/components/PageContainer";
import Skeleton from "react-loading-skeleton";
import useScreenSize from "../../hoc/useScreenSize";
import styles from "./styles.module.scss";

function CMSPagePlaceHolder() {
  const [isMobile] = useScreenSize();

  if (isMobile) {
    return (
      <PageContainer>

        <Skeleton height={38} count={1} />

        <Skeleton height={50} count={1} />

        <Skeleton height={100} count={1} />

        <Skeleton height={180} count={4} />
      </PageContainer>
    );
  }
  return (
    <PageContainer
      className={classNames(styles.flex_display, "row row-5-padding")}
      style={{ minHeight: "100%" }}
    >

      <Skeleton height={250} />

      <Skeleton height={45} />

      <Skeleton height={20} />

      <Skeleton height={180} count={4} />
    </PageContainer>
  );
}

export default CMSPagePlaceHolder;
